/*
 * Public API Surface of @eforall/dashboard
 */

export * from './frame';
export * from './pages/error/error-404-page/error-404.page';
export * from './pages/error/error.part';
export * from './services';
export * from './types';
export * from './widgets';

